import http from '@/utils/request';
import global_ from '@/utils/Global'
let apiUrl = global_.BASE_URL;


/*获取数据列表*/
export const getDataList = params => {
  return http.requestPost(apiUrl + '/Warehouse_warrant/search', params)
}

/*添加*/
export const addData = params => {
  return http.requestPost(apiUrl + '/Business/add', params)
}

/*删除*/
export const deleteData = params => {
  return http.requestPost(apiUrl + '/Business/real_delete', params)
}

/*根据id获取信息*/
export const getById = params => {
  return http.requestPost(apiUrl + '/Business/get_by_id', params)
}

/*修改保存*/
export const editData = params => {
  return http.requestPost(apiUrl + '/Business/update', params)
}



// WEBPACK FOOTER //
// ./src/components/page/shuomingcard/api/shuomingcard.js